import React, { useEffect, useState } from 'react';

/**
 * Баннер при cookie crm_preview=dev —
 * те же URL страниц, другая сборка (build-dev).
 */
const PreviewModeBanner = () => {
    const [active, setActive] = useState(false);

    useEffect(() => {
        const fromCookie = /(?:^|;\s*)crm_preview=dev(?:;|$)/.test(
            document.cookie || ''
        );
        setActive(fromCookie);

        const params = new URLSearchParams(
            window.location.search || ''
        );
        if (params.get('crm_dev') === '1' && !fromCookie) {
            const next =
                window.location.pathname +
                window.location.hash;
            window.location.replace(
                `/api/preview/dev?next=${encodeURIComponent(next || '/')}`
            );
        }
    }, []);

    if (!active) return null;

    return (
        <div
            style={{
                position: 'fixed',
                zIndex: 10000,
                left: 12,
                bottom: 12,
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '8px 12px',
                borderRadius: 8,
                background: '#0f172a',
                color: '#f8fafc',
                fontSize: 13,
                boxShadow: '0 8px 24px rgba(15,23,42,0.25)',
                maxWidth: 'min(440px, calc(100vw - 24px))'
            }}
        >
            <span
                style={{
                    background: '#f59e0b',
                    color: '#111',
                    fontWeight: 700,
                    fontSize: 11,
                    padding: '2px 6px',
                    borderRadius: 4,
                    letterSpacing: 0.4
                }}
            >
                DEV
            </span>
            <span style={{ lineHeight: 1.35 }}>
                Метка DEV: вы на черновике. URL как в проде.
            </span>
            <a
                href="/api/preview/off"
                style={{
                    color: '#93c5fd',
                    whiteSpace: 'nowrap',
                    marginLeft: 4
                }}
            >
                Снять метку
            </a>
        </div>
    );
};

export default PreviewModeBanner;
